import { render, staticRenderFns } from "./RegisterCoach.vue?vue&type=template&id=1a84cb9e&scoped=true&"
import script from "./RegisterCoach.vue?vue&type=script&lang=js&"
export * from "./RegisterCoach.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCoach.vue?vue&type=style&index=0&id=1a84cb9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a84cb9e",
  null
  
)

export default component.exports